import 'babel-polyfill'

import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, HashRouter } from 'react-router-dom'
import { unregister } from './registerServiceWorker'

import 'react-day-picker/lib/style.css'

import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/lib/integration/react'

import { createStore, applyMiddleware } from 'redux'
import { persistStore } from 'redux-persist'
import reduxThunk from 'redux-thunk'

import Reducers from './state/reducers/reducers'
import { taskWatchdog } from './state/debug/task-watchdog'
import { composeWithDevTools } from 'redux-devtools-extension'

import AppContainer from 'components/app-container/app-container'

import {
	isCordova,
} from './env.js'

import {
	preloadImages
} from 'utils'

import { initAnalytics } from 'utils/analytics'

import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'

import 'styles/app2.sass'

Bugsnag.start({
	apiKey: 'fbc168c3d605477a90ecc946e26ebb1f',
	plugins: [new BugsnagPluginReact()]
})

const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React)

initAnalytics()

unregister()

export const store = createStore(
	Reducers,
	undefined,
	composeWithDevTools(
		applyMiddleware(reduxThunk, taskWatchdog),
	)
)

export const persistor = persistStore(store, null, (err, restoredState) => {
	store.getState()
})

const Router = isCordova ? HashRouter : BrowserRouter

// gets onboarding images
preloadImages()

ReactDOM.render((
	<ErrorBoundary>
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<Router>
					<AppContainer />
				</Router>
			</PersistGate>
		</Provider>
	</ErrorBoundary>
), document.getElementById('root'))